import { useContext, useEffect, useRef } from "react";
import {
  NewProjectContext,
  type NewProjectContextValue,
  type NewProjectCreatedHandler,
} from "@/pages/projekte/newProjectContextValue";

export function useNewProject(): NewProjectContextValue {
  const ctx = useContext(NewProjectContext);
  if (!ctx) {
    throw new Error(
      "useNewProject() muss innerhalb von <NewProjectProvider> verwendet werden.",
    );
  }
  return ctx;
}

/**
 * Praktischer Hook: registriert sich automatisch für die Lebensdauer des
 * aufrufenden Components als Listener für neu angelegte Projekte.
 */
export function useOnProjectCreated(handler: NewProjectCreatedHandler) {
  const { subscribe } = useNewProject();
  const ref = useRef(handler);
  useEffect(() => {
    ref.current = handler;
  }, [handler]);
  useEffect(() => {
    return subscribe((order) => ref.current(order));
  }, [subscribe]);
}
